import React from 'react';
import './NoPage.css'

function NoPage() {
  return (
    <div>NoPage</div>
  )
}

export default NoPage